<div class="financing-calculator">
  <div class="financing-calculator__main">
    <div class="financing-calculator__main-header">
      {{ 'financingCalculator.supTitle' | translate }}
      <app-title class="financing-calculator__main-title" [tag]="'h2'" [tag-class]="'h4'">{{ 'financingCalculator.title' | translate }}</app-title>
    </div>
    <div class="financing-calculator__list">
      @for (item of 'financingCalculator.benefits' | translate; track $index) {
        <div class="financing-calculator__list-item">
          <app-icon-box [icon]="item.icon" [size]="'small'" [color]="'grey'" [rounded]="true"></app-icon-box>
          <div class="financing-calculator__list-info">
            <h3 class="financing-calculator__list-title">{{ item.title }}</h3>
            {{ item.description }}
          </div>
        </div>
      }
    </div>
    <div class="financing-calculator__box">
      <strong class="financing-calculator__box-title">{{ 'financingCalculator.financingOffer.title' | translate }}</strong>
      {{ 'financingCalculator.financingOffer.description' | translate }}
    </div>
    <div class="financing-calculator__partners">
      @for (item of partnersService.partners(); track $index) {
        @if (item && item.name && item.logo) {
          <app-image [src]="'https://admin.mototechna.cz' + item.logo.url" [alt]="item.name" [width]="item.logo.width" [height]="item.logo.height"></app-image>
        }
      }
    </div>
  </div>

  <div class="financing-calculator__calculator">
    <div class="financing-calculator__calculator-header">
      {{ 'financingCalculator.supTitle' | translate }}
      <app-title [tag]="'h2'" [tag-class]="'h4'">{{ 'financingCalculator.title' | translate }}</app-title>
    </div>
    <app-financing-calculator-form [car-id]="car.id" [car-price]="car.price.cash" [car-payment-options]="car.paymentOptions" (data-changed)="setFinancingCalculator($event)"></app-financing-calculator-form>
  </div>
</div>
